import React from "react";
import { BookOpenIcon, EyeIcon, PlayIcon } from "lucide-react";
import { teachSteps } from "../../data/content";
const icons = [BookOpenIcon, EyeIcon, PlayIcon];
export function OpenLookTeach() {
  return <section aria-labelledby="olt-title" className="bg-navy" data-id="element-163" data-mp="3mcnjm18yuilg">
      <div className="container-x py-14 sm:py-20 lg:py-24" data-id="element-164" data-mp="3rap3goe7ulxz">
        <div className="max-w-[44rem]" data-id="element-165" data-mp="3rb8inxchew8b">
          <p className="eyebrow" data-id="element-166" data-mp="iux20asdame2">The ready-to-teach book</p>
          <h2 id="olt-title" className="section-title mt-4" data-id="element-167" data-mp="ivf1dgabtgq7">
            Open it. Look. <span className="text-cyan" data-id="element-168" data-mp="nsyhklql43ks">Teach.</span>
          </h2>
        </div>

        <ol className="mt-8 grid gap-0 border-t-2 border-cyan md:mt-10 md:grid-cols-3 lg:mt-14" data-id="element-169" data-mp="95lq6ge3j3mh">
          {teachSteps.map((step, i) => {
          const Icon = icons[i];
          return <li key={step.title} className="flex gap-4 border-b border-white/10 py-5 md:flex-col md:gap-4 md:border-b-0 md:border-l md:px-8 md:py-10 md:first:border-l-0 md:first:pl-0" data-id="element-170" data-mp="11t9cq0yxg4br" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[10px] bg-cyan/10 text-cyan md:h-14 md:w-14" data-id="element-171" data-mp="2totg858gnivq">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-172" data-mp="32glp4bhu6jy7" />
                </span>
                <div data-id="element-173" data-mp="32igcdwgkyo5g">
                  <h3 className="font-display text-[26px] font-extrabold uppercase leading-none text-ice md:text-[38px]" data-id="element-174" data-mp="2xq586het4g73">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 max-w-[22rem] text-[15px] leading-relaxed text-ice/75 md:mt-2 md:text-base" data-id="element-175" data-mp="3cgmcq9mqnm87">{step.text}</p>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}